<template>
    <div class="selector-list-wrapper" :class="{ open: showList }"  :style="{top: mapHeight +'vw'}">
        <div class="selector-list">
            <div class="selector-list__header">
                <span class="selector-list__header--title" >{{ $filteredObjects.length }} van {{ $getAllObjects.length }} appartementen</span>
            </div>
            <div class="selector-list__body" ref="houseList">

                <house-tile
                        v-for="(house, i)  in $filteredObjects"
                        :house="house"
                        :key="house.id"
                        :houseindex="i"
                        ref="housetile"
                ></house-tile>


                <button @click="hideSelectorList" class="show-map btn btn-primary icon-map d-block d-lg-none">Kaart weergeven</button>

            </div>
        </div>
        <button @click="showSelectorList" :class="{ toggled: showList }" class="show-list btn btn-toggle">Lijst weergeven</button>
    </div>
</template>


<script>

    import HouseTile from '../components/HouseTile.vue'
    export default {
        components: {
            HouseTile,
        },
        props: {
            mapheight: {
                type: [Number, String]
            }
        },
        data() {
            return {
                showList: false,
                parent:  this.$parent,
                mapHeight: ''
            }
        },

        mounted(){
          this.topHeight();
        },
        methods: {
            showSelectorList () {
                this.showList = !this.showList
                this.$store.commit('highlight', null)

                if (this.parent.$el.classList.contains('selector-wrapper')) {
                    this.parent.hideSlider()
                }
                if(window.innerWidth <= 768) {
                    this.mapHeight = '0'
                }
            },
            hideSelectorList () {
                this.showList = !this.showList

                if (this.parent.$el.classList.contains('selector-wrapper')) {
                    this.parent.hideSlider()
                }
                if(window.innerWidth <= 768) {
                    this.mapHeight = this.mapheight
                }
            },

            topHeight(){
                if(window.innerWidth <= 768) {
                    this.mapHeight = this.mapheight
                }
            }
        },



    }
</script>
